export default function SpecFooter() {
	return (
		<footer
			style={{
				position: 'fixed',
				bottom: 0,
				left: 0,
				width: '100%',
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				zIndex: 600,
			}}
		>
			<span
				style={{
					display: 'block',
					padding: '1px 8px 2px',
					textAlign: 'center',
					background: '#ffffff',
					width: '100%',
					color: '#4d4d4d',
					fontSize: '12px',
					borderRadius: '4px',
				}}
			>
				Powered by SocialVoice.ai
			</span>
		</footer>
	);
}
